import { render } from "./GraficoProjetoVida.vue?vue&type=template&id=3accb74d"
import script from "./GraficoProjetoVida.vue?vue&type=script&lang=js"
export * from "./GraficoProjetoVida.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__